import { useMemo } from 'react';
import { useCoachOrganization } from './useCoachOrganization';
import { useCoachTeams } from './useCoachTeams';

/** Sidebar + teams page copy for org and legacy coaches. */
export function useCoachTeamNavContext() {
  const { data: organization } = useCoachOrganization();
  const { data: teams = [] } = useCoachTeams();

  return useMemo(() => {
    const userTeams = teams.filter((m) => !m.team.is_demo);
    const hasOrganization = !!organization;
    const hasAssignedTeams = userTeams.length > 0;
    const isProfileComplete = hasOrganization && hasAssignedTeams;
    const orgName = organization?.organizationName ?? 'your organization';

    return {
      organization,
      hasOrganization,
      hasAssignedTeams,
      isProfileComplete,
      navLabel: 'Teams',
      recentSectionLabel: 'Recent teams',
      membershipsActionLabel: 'Manage teams',
      membershipsModalTitle: 'Manage teams',
      pageTitle: 'Teams',
      pageSubtitle: isProfileComplete
        ? `Your teams at ${orgName}`
        : hasOrganization
          ? `Choose which teams you coach at ${orgName}`
          : 'Teams you belong to',
    };
  }, [organization, teams]);
}
